module.exports = __webpack_public_path__ + "static/media/alin_pavel.8aa5fe82.jpg";